import React from "react";

const PageLayout = ({children, ...rest}) => {
    return (
        <>
            {children}
        </>
    )
}

export default PageLayout
